export default "__VITE_ASSET__eRifvMl3__"